import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CalendarModule } from './calendar/calendar.module';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { CommonPageComponentsModule } from '../common-page-components/common-page-components.module';
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    CalendarModule,
    HttpClientModule,
    CommonPageComponentsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
